import account from "./account.json";
import auth from "./auth.json";
import chat from "./chat.json";
import common from "./common.json";
import deathScreen from "./deathScreen.json";
import errors from "./errors.json";
import estate from "./estate.json";
import gasStation from "./gasStation.json";
import house from "./house.json";
import hud from "./hud.json";
import inventory from "./inventory.json";
import notification from "./notification.json";
import notifications from "./notifications.json";
import playerMenu from "./playerMenu.json";
import spawn from "./spawn.json";
import targetMenu from "./targetMenu.json";
import validation from "./validation.json";

export default {
  notifications,
  auth,
  inventory,
  account,
  common,
  chat,
  spawn,
  notification,
  house,
  deathScreen,
  gasStation,
  errors,
  targetMenu,
  validation,
  hud,
  playerMenu,
  estate,
};
